// extracted by mini-css-extract-plugin
module.exports = {"iconContainer":"style__iconContainer__uh0Ge","icon":"style__icon__Nq2oR"};